'use client'

import { useLocalAudioOutput } from 'amazon-chime-sdk-component-library-react'
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/outline'
import { useTranslations } from '@/lib/next-shim'

export function AudioOutputControl() {
  const { isAudioOn, toggleAudio } = useLocalAudioOutput()
  const t = useTranslations('meetingControls.speaker')
  const tooltip = isAudioOn ? t('mute') : t('unmute')

  return (
    <div className="ds-tooltip" data-tip={tooltip}>
      <button
        type="button"
        className="flex rounded-full bg-white/10 p-2 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onClick={toggleAudio}
        aria-label={tooltip}
      >
        {isAudioOn ? <SpeakerWaveIcon className="h-5 w-5" /> : <SpeakerXMarkIcon className="h-5 w-5" />}
      </button>
    </div>
  )
}
